import {PluginNames} from '../Settings';

/**
 * Utility class for ajax requests
 */
class AjaxUtility {
  /**
   * Executes a ajax request to the server and returns a jqXHR Promise Object
   * @param {int} type
   * @param {object} params
   * @param {object} pluginNames
   * @param {string} url
   * @returns {jqXHR|Promise}
   */
  request(type, params = {}, pluginNames = PluginNames, url = window.location.origin) {
    let data = {
      type: type
    };

    if (pluginNames[type] !== undefined) {
      // set params under plugin name
      data[pluginNames[type]] = params;
    } else {
      // set params normally
      Object.assign(data, params);
    }

    return $.ajax({
      url: url,
      type: 'GET',
      data: data
    });
  }
}

export default (new AjaxUtility);
